// misc
import React from 'react';
import HttpsRedirect from 'react-https-redirect';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import { ConnectedRouter } from 'react-router-redux';
import 'core-js';
import 'semantic-ui-css/semantic.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import registerServiceWorker from './registerServiceWorker';
import configureStore from './store';

// styles
import './index.css';

// components
import App from './App';

const history = createHistory();
const store = configureStore(history);

ReactDOM.render(
  <Provider store={store}>
	<HttpsRedirect>
		<ConnectedRouter history={history}>
		  <App />
		</ConnectedRouter>
	</HttpsRedirect>
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker(); 



// WEBPACK FOOTER //
// ./src/index.js